export function getParsedError(error: unknown, errorCode: number): string {
  const strings: string[] = [];

  function extractStrings(obj: unknown) {
    if (Array.isArray(obj)) {
      for (const item of obj) {
        if (typeof item === 'string') {
          strings.push(item);
        } else if (isObject(item) || Array.isArray(item)) {
          extractStrings(item);
        }
      }
    } else if (isObject(obj)) {
      for (const key in obj) {
        if (typeof obj[key] === 'string') {
          strings.push(obj[key]);
        } else if (isObject(obj[key]) || Array.isArray(obj[key])) {
          extractStrings(obj[key]);
        }
      }
    }
  }

  extractStrings(error);

  return strings.length > 0
    ? strings.join(', ')
    : `Error: Failed request, error code: ${errorCode}`;
}

function isObject(val: unknown): val is Record<string, unknown> {
  return typeof val === 'object' && !Array.isArray(val) && val !== null;
}
